import { render } from "./Teaching.vue?vue&type=template&id=0349ba50&scoped=true"
import script from "./Teaching.vue?vue&type=script&lang=js"
export * from "./Teaching.vue?vue&type=script&lang=js"

import "./Teaching.vue?vue&type=style&index=0&id=0349ba50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0349ba50"

export default script